import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'
import type { IWithdrawChannel, IWithdrawMethodItem } from '@/types/interfaces';

export interface IWithdraw {
  channelList: IWithdrawChannel[]
  activeMethodsAccount?: IWithdrawMethodItem
  [key: string]: any
}

const initialState: IWithdraw = {
  channelList: [],
}

export const slice = createSlice({
  name: 'withdrawInfo',
  initialState,
  reducers: {
    setWithdrawInfo: (state, action: PayloadAction<IWithdraw>) => {
      const payload = action.payload
      setStoreState(state, payload)
      storageUtil.setSessionStorage('withdrawInfo', JSON.stringify(payload))
    },
  },
})

export const { setWithdrawInfo: withdrawInfoActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useWithdrawInfoStore() {
  const state = useSelector((state: RootState) => state.withdrawInfo)
  const storageState = storageUtil.getSessionStorage('withdrawInfo', true) || {}
  const actionPool = useDispatchActions(slice.actions)
  const totalState = { ...state, ...storageState }

  return {
    withdrawInfo: totalState,
    ...actionPool,
  }
}
